"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const formatWithPattern = (pattern, amount, symbol) => pattern.split("").map(char => {
    if (char === "n") {
        return amount;
    }
    else if (char === "$") {
        return symbol;
    }
    return char;
}).join("");
exports.default = formatWithPattern;
